<template>
  <div class="c-header__user-menu">
    <div class="o-grid -vertical-gutter -xs-gutter-large -md-gutter-medium l-user-menu-wrapper">
      <template v-if="user.isOnVacation">
        <div class="o-grid__item -xs-24">
          <StoreVacationInfo />
        </div>
      </template>

      <template v-else>
        <div class="l-user-menu__profile o-grid__item -xs-24">
          <div class="o-grid -xs-gutter-medium -xs-middle">
            <div class="o-grid__item -xs-shrink t-md-hide">
              <img
                class="l-user-menu__profile-avatar o-avatar -rounded -small js-header-avatar-preview"
                :src="user.avatarUrl"
                alt=""
              >
            </div>

            <div class="o-grid__item -xs-shrink">
              <div class="l-user-menu__profile-greeting o-text -xs-spaced -xs-semibold -xs-extra-dark -xs-lowercase">
                {{ randomGreeting }}
              </div>

              <div class="l-user-menu__profile-member-since o-text -xs-long-primer -xs-medium -xs-neutral-800 -xs-lowercase">
                {{ user.memberSinceText }}
              </div>
            </div>
          </div>
        </div>

        <div class="o-grid__item -xs-24">
          <div class="o-grid -vertical-gutter -xs-gutter-small">
            <div class="o-grid__item -xs-24">
              <a
                :href="user.profilePath"
                class="o-button -xs-large -xs-secondary -xs-flat t-fill"
                data-testid="button-menu-store"
                @click="registerInteraction('store')"
              >
                minha loja
              </a>
            </div>

            <div class="o-grid__item -xs-24 t-md-hide">
              <a
                href="/quero-vender"
                class="o-button -xs-large -xs-primary -xs-flat t-fill"
                data-testid="button-menu-sell"
                @click="registerInteraction('sell')"
              >
                quero vender
              </a>
            </div>
          </div>
        </div>
      </template>

      <div class="o-grid__item -xs-24">
        <div class="o-grid -vertical-gutter -xs-gutter-large -md-gutter-medium">
          <div
            v-if="isMyEnjoeiEnabled"
            class="o-grid__item -xs-24"
          >
            <a
              href="/meu-enjoei"
              class="c-header__user-menu-link"
              data-testid="button-menu-my-enjoei"
              @click="onClickMyEnjoei"
            >
              <Icon
                name="heart-happy-face"
                spaced="right"
                :size="{ xs: 'medium', md: 'small' }"
              />

              meu enjoei
            </a>
          </div>

          <div
            v-if="isMyEnjoeiEnabled"
            class="o-grid__item -xs-24"
          >
            <a
              href="/meu-enjoei/continue-comprando"
              class="c-header__user-menu-link"
              data-testid="button-menu-pending-carts"
              @click="onFavoritesLinkClick"
            >
              <Icon
                name="bag"
                spaced="right"
                :size="{ xs: 'medium', md: 'small' }"
              />

              continue comprando

              <span
                v-if="isMobile && user.pendingCartsCount > 0"
                class="o-count"
              >
                {{ user.pendingCartsCount }}
              </span>
            </a>
          </div>

          <div class="o-grid__item -xs-24 t-lg-hide">
            <a
              href="/perfil/mensagens"
              class="c-header__user-menu-link"
              data-testid="button-menu-inbox"
              @click="registerInteraction('inbox')"
            >
              <Icon
                name="inbox"
                spaced="right"
                :size="{ xs: 'medium', md: 'small' }"
              />

              mensagens

              <InboxNotification show-count />
            </a>
          </div>

          <div
            v-if="isMegaphoneEnabled"
            class="o-grid__item -xs-24"
          >
            <a
              :href="user.profilePath"
              class="c-header__user-menu-link"
              data-testid="button-menu-megaphone"
              @click="registerInteraction('megaphone')"
            >
              <Icon
                name="megaphone"
                spaced="right"
                :size="{ xs: 'medium', md: 'small' }"
              />

              megafone
            </a>
          </div>


          <div class="o-grid__item -xs-24">
            <a
              href="/central-de-vendas"
              class="c-header__user-menu-link"
              data-testid="button-menu-user-sales"
              @click="registerInteraction('sales')"
            >
              <Icon
                name="store"
                spaced="right"
                :size="{ xs: 'medium', md: 'small' }"
              />

              minhas vendas

              <span
                v-if="user.soldNotificationsCount > 0"
                class="o-count"
              >
                {{ user.soldNotificationsCount }}
              </span>
            </a>
          </div>

          <div class="o-grid__item -xs-24">
            <a
              href="/perfil/compras"
              class="c-header__user-menu-link"
              data-testid="button-menu-user-purchases"
              @click="registerInteraction('purchases')"
            >
              <Icon
                name="cart"
                spaced="right"
                :size="{ xs: 'medium', md: 'small' }"
              />

              minhas compras
            </a>
          </div>

          <div class="o-grid__item -xs-24">
            <a
              href="/enjubank"
              class="c-header__user-menu-link"
              data-testid="button-menu-enjubank"
              @click="registerInteraction('enjubank')"
            >
              <Icon
                name="cash"
                spaced="right"
                :size="{ xs: 'medium', md: 'small' }"
              />

              enjubank
            </a>
          </div>

          <div class="o-grid__item -xs-24">
            <a
              :href="user.likedProfilePath"
              class="c-header__user-menu-link"
              data-testid="button-menu-liked-products"
              @click="registerInteraction('liked_products')"
            >
              <Icon
                name="yeah-yeah"
                spaced="right"
                :size="{ xs: 'medium', md: 'small' }"
              />

              yeyezados
            </a>
          </div>

          <div class="o-grid__item -xs-24">
            <a
              href="/perfil/alterar"
              class="c-header__user-menu-link"
              data-testid="button-menu-settings"
              @click="registerInteraction('settings')"
            >
              <Icon
                name="cog"
                spaced="right"
                :size="{ xs: 'medium', md: 'small' }"
              />

              configurações
            </a>
          </div>

          <div class="o-grid__item -xs-24">
            <a
              href="/ajuda"
              class="c-header__user-menu-link"
              data-testid="button-menu-help"
              @click="registerInteraction('help')"
            >
              <Icon
                name="help"
                spaced="right"
                :size="{ xs: 'medium', md: 'small' }"
              />

              ajuda
            </a>
          </div>

          <div class="o-grid__item -xs-24">
            <form
              action="/usuario/sair"
              method="post"
              @submit.prevent="handleLogout"
            >
              <input
                name="_method"
                type="hidden"
                value="delete"
              >

              <input
                name="authenticity_token"
                type="hidden"
                :value="authenticityToken"
              >

              <button
                class="c-header__user-menu-link"
                data-testid="button-menu-logout"
                type="submit"
              >
                <Icon
                  name="logout"
                  spaced="right"
                  :size="{ xs: 'medium', md: 'small' }"
                />

                sair
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  import STORE_TYPES_SESSION from '@/web/store/registered/session'
  import { pushInteraction } from '@/tools/data-layer/data-layer'
  import { fillMetaElementWithAuthenticityToken } from '@/tools/session'
  import { callWithTimeout } from '@/tools/call-with-timeout'
  import { storage } from '@/tools/storage'
  import { STORAGE } from '@/tools/storage/constants'
  import media from '@/tools/mixins/media'
  import logger from '@/tools/logger/logger'

  import Icon from '@/web/components/icon.vue'
  import StoreVacationInfo from '@/web/components/store-vacation-info.vue'
  import InboxNotification from '@/web/components/header/inbox-notification.vue'

  import '@engines/stylesheets/ui/objects/_text.scss'
  import '@engines/stylesheets/ui/objects/_grid.scss'
  import '@engines/stylesheets/ui/objects/_avatar.scss'
  import '@engines/stylesheets/ui/objects/_button.scss'
  import '@engines/stylesheets/ui/objects/_count.scss'
  import '@engines/stylesheets/ui/trumps/_overrides.scss'

  export default {
    components: {
      Icon,
      StoreVacationInfo,
      InboxNotification
    },
    mixins: [
      media
    ],
    props: {
      user: {
        type: Object,
        required: true
      },
      isMegaphoneEnabled: {
        type: Boolean,
        default: false
      },
      inboxBackgroundTabNotificationInterval: {
        required: false,
        type: Number,
        default: 0
      }
    },
    data() {
      return {
        // If device does not support localStorage, we assume it is not the first
        // time the user is seeing the menu to avoid showing a "NOVO" label forever.
        hasSeenMyEnjoei: !storage.local.enabled || storage.local.get('has-seen-my-enjoei')
      }
    },
    computed: {
      ...mapGetters({
        authenticityToken: STORE_TYPES_SESSION.GETTERS.GET_AUTHENTICITY_TOKEN
      }),
      randomGreeting() {
        const greetings = [
          `Olá, ${this.user.firstName}!`,
          `Fala, ${this.user.firstName}!`,
          `Ei, ${this.user.firstName}!`,
          `E aí, ${this.user.firstName}?`,
          `Hello, ${this.user.firstName}!`,
          `${this.user.firstName}, tá jóia?`,
          `Oi, ${this.user.firstName}!`,
          `Colé, ${this.user.firstName}!`,
          `${this.user.firstName}, na paz?`,
          `Bão, ${this.user.firstName}?`
        ]

        return greetings[Math.floor(Math.random() * greetings.length)]
      },
      isMyEnjoeiEnabled() {
        return this.user.isMyEnjoeiEnabled
      }
    },
    watch: {
    },
    mounted() {
    },
    methods: {
      onFavoritesLinkClick() {
        this.registerInteraction('pending_carts')
      },
      onClickMyEnjoei() {
        this.registerInteraction('my_enjoei')
        storage.local.set('has-seen-my-enjoei', true)
      },
      registerInteraction(content) {
        pushInteraction({ context: 'user_menu', type: 'click', content })
      },
      async handleLogout(event) {
        this.registerInteraction('logout')
        storage.session.remove(STORAGE.staleCurrentUser)

        try {
          await callWithTimeout(
            fillMetaElementWithAuthenticityToken.bind(null, { shouldFetchUpdatedValue: true }),
            2000
          )
        } catch (error) {
          if (!error.message.includes('Timeout error')) {
            logger.error(error)
          }
        }

        event.target.submit()
      }
    }
  }
</script>

<style lang="scss" scoped>

  .c-header__user-menu-link .o-count {
    background-color: $color-green-neon-100;
    color: $color-primary;
    padding: 6px 5px;
    min-width: 20px;
    height: 22px;
    border-radius: 24px;
    font-size: 10px;
    font-weight: $font-weight-semi-bold;
    margin-left: 8px;
    line-height: 10px;
    margin-top: 0;
  }
  .l-user-menu {
    &__profile {
      &-avatar {
        height: 56px;
        width: 56px;
      }

      &-greeting {
        font-size: 20px;
        font-weight: $font-weight-bold;
        line-height: 28px;
        color: $color-neutral-900;
      }

      &-member-since {
        line-height: 24px;
      }
    }
  }

  .o-grid.-vertical-gutter.-xs-gutter-large.-md-gutter-medium > .o-grid__item {
    padding-top: 16px;
    padding-bottom: 16px;

    @include breakpoint($from: md) {
      padding-top: 12px;
      padding-bottom: 12px;
    }
  }

  .o-grid.-vertical-gutter.-xs-gutter-large.-md-gutter-medium.l-user-menu-wrapper > .o-grid__item {
    &:nth-child(1) {
      padding-top: 32px;
      padding-bottom: 0;

      @include breakpoint($from: md) {
        padding-top: 24px;
      }
    }

    &:nth-child(2) {
      padding-top: 24px;
      padding-bottom: 24px;
    }
  }

  .o-grid__item.-xs-24.t-md-hide {
    padding-top: 12px;
  }

  .o-icon {
    color: $color-primary;
    width: 24px;
    height: 24px;

    @include breakpoint($from: md) {
      width: 20px;
      height: 20px;
    }

    &.-spaced-right {
      margin-right: 12px;
    }
  }
</style>
